// Foundations
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

// Services
import { MyProfileService } from 'src/app/services/my-profile.service';
import { InterviewRequestService } from 'src/app/services/interview-request.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

// Models
import { FranchiseLocation } from '../../../models/franchise.model';

@Component({
  selector: 'app-interview-request-change-location',
  templateUrl: './interview-request-change-location.component.html',
  styleUrls: ['./interview-request-change-location.component.scss'],
})
export class InterviewRequestChangeLocationComponent implements OnInit {
  @Output() changeStep = new EventEmitter<number>();

  selectedLocation: FranchiseLocation;
  locationList: FranchiseLocation[];
  newOpt: FranchiseLocation;

  constructor(
    public myProfileService: MyProfileService,
    public interviewRequestService: InterviewRequestService,
    private _analytics: AnalyticsService
  ) {}

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.myProfileService.locationList$.subscribe((locationList) => {
      this.locationList = locationList;
      this.selectedLocation = locationList[0];

      this.newOpt = this.interviewRequestService.newOptionFromSearch;
      if (this.newOpt) {
        this.interviewRequestService.newOptionFromSearch = null;
        this.selectedLocation = this.newOpt;
      }
    });
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  changeSelectedLocationTile(location: FranchiseLocation): void {
    this.selectedLocation =
      this.selectedLocation && location.id === this.selectedLocation.id
        ? null
        : location;
  }

  onSave(): void {
    this._analytics.logButtonTap('interviewRequest_saveCampLocation');
    this.interviewRequestService.selectedLocation = this.selectedLocation;
    this.changeStep.emit(0);
  }

  onCancel(): void {
    this.changeStep.emit(0);
  }

  isNewOptUnique(id: string): boolean {
    this.locationList.forEach((location) => {
      if (location.id === id) {
        return false;
      }
    });
    return true;
  }
}
